import React from "react";
import Image from "../../image/Image";
import "./Buttons.scss";

function Buttons(props) {
  const {
    isLoading,
    buttonTypeClassName,
    onClick,
    textWithIcon,
    textWithIconFront,
    buttonText,
    buttonTextFront,
    imagePath,
    imagePathFront,
    btnTitle,
    isDisable,
  } = props;

  return (
    <button
      type="button"
      className={`btn ${buttonTypeClassName}`}
      onClick={onClick}
      title={btnTitle}
      disabled={isDisable}
    >
      {isLoading ? (
        "Loading..."
      ) : (
        <>
          {textWithIconFront && buttonTextFront}

          {textWithIconFront && (
            <div>
              <Image
                imgCustomClassName="front-btn-img "
                imagePath={imagePathFront}
                altText="Button"
              />
            </div>
          )}

          {!textWithIconFront && buttonTextFront}

          {textWithIcon && buttonText}
          {textWithIcon && (
            <Image imagePath={imagePath} altText="button Icon" />
          )}
          {!textWithIcon && buttonText}
        </>
      )}
    </button>
  );
}

export default Buttons;
